import { Button } from "antd";
import { DirectorsSteps } from "..";

import styles from "../../../LimitedLiability.module.scss";

interface IAddDirectorAction {
  handleNextStep: (_step: DirectorsSteps) => void;
}

const AddDirectorAction: React.FC<IAddDirectorAction> = ({
  handleNextStep,
}) => {
  return (
    <div className={styles.RegisteredBusinessAction}>
      <div className={styles.ActionContainer}>
        <Button
          type="primary"
          size="large"
          className={styles.ActionButton}
          onClick={() => handleNextStep(DirectorsSteps.ADD_DIRECTOR_STEPS)}
        >
          Add Director
        </Button>
      </div>
    </div>
  );
};

export default AddDirectorAction;
